import { ItemPlace } from "src/app/site/shared-components/item-location-overlay/models/model";

export class GetPlace {
    static readonly type = '[place] GetAll';
}

export class AddPlace {
    static readonly type = '[place] Add';

    constructor(public payload: ItemPlace) {
    }
}